import { _ as t } from "./export-cdcbfb2b.js";
import { o as e } from "./object-to-array-0474b7e7.js";
var o = t, a = e.entries;
o({ target: "Object", stat: !0 }, {
  entries: function(r) {
    return a(r);
  }
});
